<template>
  <b-overlay :show="loading" rounded="sm">
    <b-container fluid class="p-0">
      <b-row class="mb-3 align-items-end justify-content-between">
        <b-col sm="12" md="3">
          <div class="">
            <b-button-group>
              <b-button
                v-for="item in filter.statusTypes"
                :class="item.value === Filter_GeneralOrderStatus ? 'activeBtn' : 'deactiveBtn' + ' headerBtn'"
                @click="changeFilterStatus(item)"
                >{{ item.text }}</b-button
              >
            </b-button-group>
          </div>
        </b-col>
        <b-col sm="12" md="5" lg="3" class="mb-2 mt-3 my-md-0">
          <div class="">
            <b-input-group>
              <template v-slot:prepend>
                <b-btn style="cursor:default;" class="font-weight-bold">Event</b-btn>
              </template>
              <b-form-select @change="changeMenuType" v-model="selectedFoodMenuType" :options="FoodMenuTypes"></b-form-select>
            </b-input-group>
          </div>
        </b-col>
        <b-col
          v-if="$hasPermission([0, 1, 2, 3, 4, 5, 6, 7, 8, 10, 13]) && kdsList.length > 1"
          sm="12"
          md="3"
          class="mt-3 mb-2 mt-lg-0 mb-lg-0"
        >
          <div class="">
            <b-input-group>
              <template v-slot:prepend>
                <b-btn style="cursor:default;" class="font-weight-bold">Display</b-btn>
              </template>
              <b-form-select v-model="Filter_KDS" :options="kdsList" @change="changeKds"></b-form-select>
            </b-input-group>
          </div>
        </b-col>
        <b-col sm="12" md="4" lg="3" class="my-2 my-lg-0" v-if="$hasPermission([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13])">
          <div class="my-2 my-lg-0">
            <b-input-group size="md">
              <template v-slot:append>
                <b-btn variant="warning" size="md" @click="searchInReport" :disabled="loadingBtn">
                  <span v-if="!loadingBtn">Search</span>
                  <font-awesome-icon v-else spin icon="circle-notch" class="align-middle" />
                </b-btn>
                <b-btn v-if="showResetBtn" variant="danger" size="md" @click="resetSearch" :disabled="loadingBtn">
                  <span v-if="!loadingBtn">Reset</span>
                  <font-awesome-icon v-else spin icon="circle-notch" class="align-middle" />
                </b-btn>
              </template>
              <b-form-input type="text" name="Search" v-model="Search" />
            </b-input-group>
          </div>
        </b-col>
      </b-row>
      <b-row class="my-2" v-if="filterOrdersByKds.length">
        <b-col cols="12">
          <div class="p-2 d-flex align-items-center">
            <div>
              Total Tabs: {{ totalPage }}
              <span v-if="canceledItem.length">(including {{ canceledItem.length }} canceled)</span>
            </div>
            <div>
              <print-special-order
                :filter="filterTable($refs.table.context)"
                :menu-types="FoodMenuTypes"
                :menuTypeId="selectedFoodMenuType"
              />
              
            </div>
            <print-special-order-by-due
                :filter="filterTable($refs.table.context)"
                :menu-types="FoodMenuTypes"
                :menuTypeId="selectedFoodMenuType"
              />
          </div>
        </b-col>
        <!--                <b-col cols="6" class="text-right">-->
        <!--                    <print-special-order-->
        <!--                        :filter="filterTable($refs.table.context)"-->
        <!--                        :menu-types="FoodMenuTypes"-->
        <!--                        :menuTypeId="selectedFoodMenuType"-->
        <!--                    />-->
        <!--                </b-col>-->
      </b-row>
      <b-table
        ref="table"
        class="bg-white reportTable"
        show-empty
        stacked="md"
        details-td-class="p-0 table-light"
        :items="filterOrdersByKds"
        head-variant="dark"
        :fields="fields"
        sort-icon-left
        :empty-text="'No Records'"
        :empty-filtered-text="'NoRecords'"
        :current-page="currentPage"
        @row-clicked="openDetailsByClickOnEachRowTable"
        @context-changed="getItems"
        sort-by="Submitted"
        sort-desc
         style="font-size:1.1rem"
      >
        <template v-slot:cell(name)="data"> {{ row.value.first }} {{ data.value.last }} </template>

        <template v-slot:cell(CustomerName)="row">
          {{ row.item.CustomerName }}
          <span class="mx-2" v-if="row.item.OrderID == row.item.OriginalOrderID">
            (Party 1)
          </span>
        </template>

        <template v-slot:cell(PaymentStatus)="row">
          {{ row.item.PaymentStatus }}
          <!--                    <span v-if="showPartialRefundSymbol(row)">-->
          <!--                        *-->
          <!--                    </span>-->
          <p
            v-if="row.item.Refund && (row.item.PaymentStatusID == 1 || row.item.PaymentStatusID == 4)"
            class="text-danger small mb-0"
          >
            Tab Refunded
          </p>
        </template>
        <template v-slot:cell(TabNo)="row">
          <span>{{ row.item.TabNo }}</span>
          <span v-if="row.item.OrderTypeID === 2">
            <span v-if="row.item.TableNumber.trim().length"> - </span>
            {{ row.item.TableNumber }}
          </span>

          <serverDisplay :value="row.item.ServerName" />
        </template>

        <template v-slot:cell(DUE)="row">
          <div v-if="row.item.OrderTypeID === 0 || row.item.OrderTypeID === 1 || row.item.OrderTypeID === 3">
            <span>{{ row.item.DueTime }}</span>
            <!--                        <span v-if="row.item.OrderStatus !== 'Served' && row.item.RemainMin !== '' && row.item.OrderStatus !== 'Canceled'">-->
            <!--                            <span> | </span>-->
            <!--                            <span v-if="row.item.RemainMin < 60" style="color:#f37021">{{(row.item.RemainMin)  + ' min '}}</span>-->
            <!--                            <span style="color:#f37021" class="font-weight-bold" v-else>60+ min</span>-->
            <!--                        </span>-->
          </div>
        </template>

        <template v-slot:cell(OrderStatus)="row">
          <span style="color:#f37021" class="font-weight-bold" :class="{blinkOrderStatus: !row.item.TabAcknowledged}">
            {{ row.item.OrderStatus }}
          </span>
        </template>

        <template v-slot:cell(Submitted)="row">
          <span class="text-left">{{ validDate(row.item.OrderDate) }}</span>
        </template>
        <template v-slot:cell(details)="row">
          <b-btn size="sm" style="background: #f37021" class="text-white" @click="openDetailsByBtn(row.item)">
            <font-awesome-icon icon="list" class="align-middle" />
          </b-btn>
        </template>

        <template v-slot:row-details="row">
          <b-container fluid class="p-0">
            <b-row class="mx-0">
              <b-col sm="12" class="bg-white" v-if="row.item.Delivery_Address !== ''">
                <div class="w-50 m-auto pt-3">
                  <p class="mb-0">
                    <span class="font-weight-bold">Delivery Address: </span>
                    <span>
                      {{ row.item.Delivery_Address }}
                    </span>
                    <span class="mx-4" v-if="row.item.Delivery_UnitNo !== ''">
                      {{ 'Apt/St/Unit: ' + row.item.Delivery_UnitNo }}
                    </span>
                  </p>
                  <p class="mb-0">
                    <span class="font-weight-bold">Note: </span>
                    <span>
                      {{ row.item.Delivery_Instruction }}
                    </span>
                  </p>
                </div>
              </b-col>

              <b-col cols="12" lg="8" class="bg-white py-3">
                <div
                  class="mb-3 d-flex flex-row justify-content-between align-items-center"
                  v-if="selectedOrder.OrderStatus !== 'Canceled'"
                >
                  <b-btn
                    v-if="selectedOrder.PaymentStatusID === 1 && !dineInAndSplitByAmount(row.item)"
                    class="font-weight-bold"
                    variant="danger"
                    @click="addItem"
                  >
                    <font-awesome-icon icon="plus" class="align-middle" />
                    Add Item
                  </b-btn>
                  <span v-if="row.item.ServerName" class="mx-4 text-muted">Server: {{ row.item.ServerName }}</span>
                  <div v-if="row.item.PackagingType">
                    <div v-if="row.item.PackagingType === 'EAT IN'">
                      SERVE FOR HERE (EAT IN)
                    </div>
                    <div v-else>
                      SERVE FOR TO GO
                    </div>
                  </div>
                  <div
                    v-if="
                      row.item.OrderStatusID !== 5 &&
                        row.item.PaymentStatusID === 1 &&
                        !row.item.Credit &&
                        filterOrdersByKds.filter(
                          item => item.OrderStatusID !== 5 && item.PaymentStatusID === 1 && item.OrderID !== row.item.OrderID
                        ).length
                    "
                  >
                    <merge-tab :current-order="row.item" :orders="filterOrdersByKds" @refresh="updateMasterList" />
                  </div>
                  <div
                    class="d-flex"
                    v-if="row.item.OrderTypeID === 2 && row.item.PaymentStatusID === 1 && row.item.OrderStatusID !== 5"
                  >
                    <undo-split class="mx-2" v-if="row.item.SplitType" :order-id="row.item.OrderID" @refresh="updateReport" />
                    <template
                      v-if="
                        selectedOrder.Total - selectedOrder.Fee == '0' &&
                          getTabItems.length === 1 &&
                          getTabItems.find(i => i.Quantity === 1)
                      "
                    >
                    </template>
                    <template v-else>
                      <split-bill @refresh="updateReport" :order-id="row.item.OrderID" :order="row.item" />
                    </template>
                  </div>

                  <div v-else></div>
                </div>
                <b-row>
                  <b-col sm="12" lg="4" class="d-flex d-lg-none flex-row justify-content-center bg-white py-3">
                    <div>
                      <h5 class="font-weight-bold text-center text-dark">Order Status</h5>
                      <b-button-group
                        v-if="row.item.OrderTypeID === 0 || row.item.OrderTypeID === 1 || row.item.OrderTypeID === 3"
                      >
                        <b-button disabled :class="row.item.OrderStatus === 'New' ? 'activeBtn' : 'deactiveBtn'">NEW</b-button>
                        <b-button
                          :disabled="
                            row.item.OrderStatus === 'Canceled' ||
                            selectedOrder.PaymentStatus === 'Unpaid' ||
                            row.item.OrderStatus === 'Ready'
                              ? true
                              : false
                          "
                          @click="UpdateToGoOrderStatus(row.item.OrderID, 2, row.item.OrderStatusID)"
                          :class="row.item.OrderStatus === 'Confirmed' ? 'activeBtn' : 'deactiveBtn'"
                          >CONFIRMED</b-button
                        >
                        <b-button
                          :disabled="
                            row.item.OrderStatus === 'Canceled' ||
                            row.item.OrderStatus === 'New' ||
                            row.item.OrderStatus === 'Confirmed' ||
                            selectedOrder.PaymentStatus === 'Unpaid'
                              ? true
                              : false
                          "
                          @click="UpdateToGoOrderStatus(row.item.OrderID, 3, row.item.OrderStatusID)"
                          :class="row.item.OrderStatus === 'Ready' ? 'activeBtn' : 'deactiveBtn'"
                          >READY</b-button
                        >
                        <b-button
                          v-if="allItemsReady"
                          :disabled="
                            row.item.OrderStatus === 'Canceled' ||
                            row.item.OrderStatus === 'New' ||
                            row.item.OrderStatus === 'Confirmed' ||
                            selectedOrder.PaymentStatus === 'Unpaid'
                              ? true
                              : false
                          "
                          size="md"
                          style="cursor:pointer"
                          class="deactiveBtn"
                          @click="makeAllServe"
                          >SERVED</b-button
                        >
                        <b-button
                          v-else
                          :disabled="
                            row.item.OrderStatus === 'Canceled' ||
                            row.item.OrderStatus === 'New' ||
                            row.item.OrderStatus === 'Confirmed' ||
                            selectedOrder.PaymentStatus === 'Unpaid'
                              ? true
                              : false
                          "
                          @click="UpdateToGoOrderStatus(row.item.OrderID, 4, row.item.OrderStatusID)"
                          :class="row.item.OrderStatus === 'Served' ? 'activeBtn' : 'deactiveBtn'"
                          >SERVED</b-button
                        >
                      </b-button-group>

                      <b-button-group v-else>
                        <b-button disabled :class="row.item.OrderStatus === 'New' ? 'activeBtn' : 'deactiveBtn'">NEW</b-button>
                        <b-button disabled :class="row.item.OrderStatus === 'Ready' ? 'activeBtn' : 'deactiveBtn'"
                          >READY</b-button
                        >
                        <b-button disabled :class="row.item.OrderStatus === 'Served' ? 'activeBtn' : 'deactiveBtn'"
                          >SERVED</b-button
                        >
                      </b-button-group>

                      <div class="text-center mt-3">
                        <vue-easy-print tableShow ref="easyPrint">
                          <template slot-scope="func">
                            <div id="printFactor" class="font-weight-bold">
                              <h4 style="font-size: 25px" class="font-weight-bold">
                                {{ 'Tab  ' + row.item.TabNo + ' (' + row.item.OrderType + ') ' }}
                              </h4>
                              <p class="text-dark mb-0" style="font-size: 18px">
                                {{ 'Submitted: ' + validDate(row.item.OrderDate) }}
                              </p>
                              <p class="font-weight-bold mb-0" style="font-size: 18px">Name: {{ row.item.CustomerName }}</p>
                              <p class="font-weight-bold" style="font-size: 18px">Due: {{ row.item.DueTime }}</p>
                              <div v-for="item in printFood(getTabItems)" class="item d-flex font-weight-bold flex-row py-2">
                                <div>
                                  <p class="mb-0" style="font-size: 18px">
                                    <span>{{ item.Quantity }}x</span>
                                  </p>
                                </div>
                                <div class="px-2">
                                  <p class="mb-0 d-flex flex-column" style="font-size: 18px">
                                    <span>{{ item.ItemName }}</span>
                                    <span style="font-size:19px" v-if="item.ItemName_SecondLang !== '' && AllowSecondLang">{{
                                      item.ItemName_SecondLang
                                    }}</span>
                                  </p>
                                  <p class="mb-0" style="font-size: 15px">
                                    <span class="d-flex flex-column">
                                      <span>{{ item.PriceComment }}</span>
                                      <span
                                        style="font-size:19px"
                                        v-if="item.PriceComment_SecondLang !== '' && AllowSecondLang"
                                        >{{ item.PriceComment_SecondLang }}</span
                                      >
                                    </span>
                                  </p>
                                  <p class="mb-0" style="font-size: 15px">{{ item.Modifiers }}</p>
                                  <p
                                    v-if="item.Modifiers_SecondLang !== '' && AllowSecondLang"
                                    class="mb-0"
                                    style="font-size: 15px"
                                  >
                                    {{ item.Modifiers_SecondLang }}
                                  </p>
                                  <p class="mb-0" v-if="item.Description.trim().length">
                                    Note:{{" "+ item.Description }}
                                  </p>
                                </div>
                              </div>
                              <div v-for="item in printDrinks(getTabItems)" class="item d-flex font-weight-bold flex-row py-2">
                                <div>
                                  <p class="mb-0" style="font-size: 18px">
                                    <span>{{ item.Quantity }}x</span>
                                  </p>
                                </div>
                                <div class="px-2">
                                  <p class="mb-0" style="font-size: 18px">
                                    <span class="d-flex flex-column">
                                      <span
                                        >{{ item.ItemName }}
                                        <span class="mx-4" v-if="item.Alcoholic">
                                          * ALC. VERIFY AGE *
                                        </span>
                                      </span>
                                      <span style="font-size:19px" v-if="item.ItemName_SecondLang !== '' && AllowSecondLang">{{
                                        item.ItemName_SecondLang
                                      }}</span>
                                    </span>
                                  </p>
                                  <p class="mb-0" style="font-size: 15px">
                                    <span class="d-flex flex-column">
                                      <span>{{ item.PriceComment }}</span>
                                      <span
                                        style="font-size:19px"
                                        v-if="item.PriceComment_SecondLang !== '' && AllowSecondLang"
                                        >{{ item.PriceComment_SecondLang }}</span
                                      >
                                    </span>
                                  </p>
                                  <p class="mb-0" style="font-size: 15px">{{ item.Modifiers }}</p>
                                  <p
                                    v-if="item.Modifiers_SecondLang !== '' && AllowSecondLang"
                                    class="mb-0"
                                    style="font-size: 15px"
                                  >
                                    {{ item.Modifiers_SecondLang }}
                                  </p>
                                  <p class="mb-0" v-if="item.Description.trim().length">
                                    {{ item.Description }}
                                  </p>
                                </div>
                              </div>
                              <div class="mt-2" style="width: 6cm !important">
                                <p class="mb-0 small d-block font-weight-bold" v-if="row.item.OrderDescription !== ''">
                                  Note : {{ row.item.OrderDescription }}
                                </p>
                              </div>
                            </div>
                          </template>
                        </vue-easy-print>
                        <!--                                        <button @click="printMe" class="bg-transparent border-0 text-primary font-weight-bold">-->
                        <!--                                            <span class="font-weight-bold">Print Tab...</span>-->
                        <!--                                        </button>-->
                        <div class="d-flex justify-content-between align-items-center">
                          <div class="mt-3" v-if="HasActiveTicketPrinter">
                            <keep-alive>
                              <print-ticket
                                :loadPrint="loadPrint"
                                :items="getTabItems"
                                :AllowSecondLang="AllowSecondLang"
                                :serverIp="serverIp"
                                @callbackTicketPrint="callbackTicketPrint"
                                :info="row.item"
                                :disabled="activePrintTicketBtn.length"
                                :isSpecialEvent="true"
                              />
                            </keep-alive>
                          </div>
                          <div class="px-4">
                            <keep-alive>
                              <print-recipient
                                :loadPrint="loadPrint"
                                :items="getTabItems"
                                :info="row.item"
                                :AllowSecondLang="AllowSecondLang"
                                :HasActiveReceiptPrinter="HasActiveReceiptPrinter"
                                :HasActiveTicketPrinter="HasActiveTicketPrinter"
                                :RestaurantAddress="RestaurantAddress"
                                :RestaurantName="RestaurantName"
                                :RestaurantPhoneNumber="RestaurantPhoneNumber"
                                :RestaurantCity="RestaurantCity"
                                :RestaurantState="RestaurantState"
                                :RestaurantZIP="RestaurantZIP"
                                @callbackResult="callBackPrintServer"
                                :printers="printers"
                                :serverIp="serverIp"
                                @returnPrintes="returnPrintes"
                                :cardInfo="cardInfo"
                              />
                            </keep-alive>

                            <div v-if="errorPrintReciept !== null">
                              <p class="mt-3" :class="errorPrintReciept.hasError ? 'text-danger' : 'text-success'">
                                {{ errorPrintReciept.message }}
                              </p>
                            </div>
                            <div v-if="disconnectIps.length">
                              <b-btn variant="link" @click="showDeactiveIps = !showDeactiveIps">
                                Print Error Details...
                              </b-btn>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-table-simple responsive striped class="m-0 p-0"  style="font-size:1.1rem">
                  <b-thead>
                    <b-td> </b-td>
                    <b-td colspan="4">
                      <span v-if="dineInAndSplitByAmount(row.item)" class="text-danger font-weight-bold">
                        This tab is split by amount.
                      </span>
                    </b-td>
                    <b-td class="font-weight-bold">
                      <span v-if="HasActiveTicketPrinter">Ticket Print</span>
                    </b-td>
                  </b-thead>
                  <b-tbody>
                    <b-tr v-for="(item, index) in getTabItems" :key="'details' + index">
                      <b-td>{{ item.Quantity }}x</b-td>
                      <b-td>
                        <span v-if="selectedOrder.OrderStatusID !== 5 && !dineInAndSplitByAmount(row.item)">
                          <font-awesome-icon
                            v-if="row.item.PaymentStatusID === 1 || row.item.PaymentStatusID === 3"
                            icon="pencil-alt"
                            class="cursor-pointer"
                            @click="editItem(row.item.OrderTypeID, item.IKey, item.Price, row.item, item)"
                          />
                        </span>
                      </b-td>
                      <b-td :class="item.DrinkID !== 0 ? 'alcoholicText font-weight-bold' : 'text-dark'">
                        <span class="d-flex flex-column">
                          <span
                            >{{ item.ItemName }}
                            <span class="mx-5" v-if="item.Alcoholic" :class="item.Alcoholic ? 'alcoholicText' : 'text-dark'">
                              * ALC. VERIFY AGE *
                            </span>
                          </span>
                          <span v-if="item.ItemName_SecondLang !== '' && AllowSecondLang">{{ item.ItemName_SecondLang }}</span>
                        </span>
                        <span v-if="item.Alcoholic" :class="item.Alcoholic ? 'alcoholicText' : 'text-dark'">
                          * ALC. VERIFY AGE *
                        </span>
                        <p class="mb-0 text-danger font-weight-bold">
                          <span class="d-flex">
                            <span>{{ item.PriceComment }}</span>
                            <span class="mx-2" v-if="item.PriceComment_SecondLang !== '' && AllowSecondLang">{{
                              item.PriceComment_SecondLang
                            }}</span>
                          </span>
                        </p>
                        <p class="mb-0">
                          <span class="d-flex flex-column">
                            <span class="mb-0 font-weight-bold" style="color: red">{{ item.Modifiers }}</span>
                            <span
                              v-if="item.Modifiers_SecondLang !== '' && AllowSecondLang"
                              class="mb-0 font-weight-bold"
                              style="color: red"
                              >{{ item.Modifiers_SecondLang }}</span
                            >
                            <span class="text-danger font-weight-bold" v-if="item.Description.trim().length">
                              {{ item.Description }}</span
                            >
                          </span>
                        </p>
                      </b-td>
                      <b-td :class="item.DrinkID !== 0 ? 'alcoholicText font-weight-bold' : 'text-dark'"
                        >${{ item.Price.toFixed(2) }}
                        <span class="mb-4 d-inline-block" v-if="dineInAndSplitByAmount(row.item)">*</span>
                        <p
                          v-if="dineInAndSplitByAmount(row.item) && index === getTabItems.length - 1"
                          class="font-italic text-dark"
                        >
                          *Pre-split price
                        </p>
                      </b-td>
                      <b-td class="text-center">
                        <b-button-group v-if="row.item.OrderTypeID === 2">
                          <b-button
                            :disabled="selectedOrder.OrderStatus === 'Canceled'"
                            size="md"
                            @click="UpdateOrderDetailsStatus(item.IKey, 1)"
                            :class="item.OrderStatus === 1 ? 'activeBtn' : 'deactiveBtn'"
                            >NEW</b-button
                          >
                          <b-button
                            :disabled="selectedOrder.OrderStatus === 'Canceled'"
                            size="md"
                            @click="UpdateOrderDetailsStatus(item.IKey, 3)"
                            :class="item.OrderStatus === 3 ? 'activeBtn' : 'deactiveBtn'"
                            >READY</b-button
                          >
                          <b-button
                            :disabled="selectedOrder.OrderStatus === 'Canceled'"
                            size="md"
                            @click="UpdateOrderDetailsStatus(item.IKey, 4)"
                            :class="item.OrderStatus === 4 ? 'activeBtn' : 'deactiveBtn'"
                            >SERVED</b-button
                          >
                        </b-button-group>
                        <b-button-group
                          v-else-if="row.item.OrderTypeID === 0 || row.item.OrderTypeID === 1 || row.item.OrderTypeID === 3"
                        >
                          <b-button
                            size="md"
                            :key="`status-btn-${item.IKey}-1`"
                            :id="`status-btn-${item.IKey}-1`"
                            :disabled="selectedOrder.OrderStatus === 'Canceled'"
                            :style="row.item.OrderStatus === 'New' ? 'cursor: default' : 'cursor:pointer'"
                            :class="item.OrderStatus === 1 || item.OrderStatus === 2 ? 'activeBtn' : 'deactiveBtn'"
                            @click="
                              UpdateToGoOrderDetailsStatus(row.item.OrderStatus, row.item.OrderID, item.IKey, 1, item.OrderStatus)
                            "
                            >NEW</b-button
                          >
                          <b-button
                            size="md"
                            :key="`status-btn-${item.IKey}-3`"
                            :id="`status-btn-${item.IKey}-3`"
                            :disabled="selectedOrder.OrderStatus === 'Canceled'"
                            :style="row.item.OrderStatus === 'New' ? 'cursor: default' : 'cursor:pointer'"
                            :class="item.OrderStatus === 3 ? 'activeBtn' : 'deactiveBtn'"
                            @click="
                              UpdateToGoOrderDetailsStatus(row.item.OrderStatus, row.item.OrderID, item.IKey, 3, item.OrderStatus)
                            "
                            >READY</b-button
                          >
                          <b-button
                            size="md"
                            :disabled="selectedOrder.OrderStatus === 'Canceled'"
                            :key="`status-btn-${item.IKey}-4`"
                            :id="`status-btn-${item.IKey}-4`"
                            :style="row.item.OrderStatus === 'New' ? 'cursor: default' : 'cursor:pointer'"
                            :class="item.OrderStatus === 4 ? 'activeBtn' : 'deactiveBtn'"
                            @click="
                              UpdateToGoOrderDetailsStatus(row.item.OrderStatus, row.item.OrderID, item.IKey, 4, item.OrderStatus)
                            "
                            >SERVED</b-button
                          >
                        </b-button-group>
                      </b-td>
                      <b-td>
                        <div v-if="HasActiveTicketPrinter" class="d-flex justify-content-start">
                          <div>
                            <b-form-checkbox
                              class="m-auto"
                              :id="'checkbox' + index"
                              v-model="item.checked"
                              :name="'checkbox' + index"
                              :value="true"
                              :disabled="item.disabled || row.item.OrderStatusID == 1"
                              :unchecked-value="false"
                            >
                            </b-form-checkbox>
                          </div>
                          <div>
                            <font-awesome-icon
                              v-b-tooltip
                              title="printed"
                              v-if="item.IsPrinted"
                              icon="check"
                              class="m-auto mx-1 text-success align-middle"
                            />
                            <font-awesome-icon
                              :class="'m-auto text-center mx-1'"
                              @click="showErrorPrintTicket(item)"
                              v-if="!item.printed && item.failur"
                              icon="info"
                              style="cursor: pointer"
                              class="text-danger align-middle"
                            />
                          </div>
                        </div>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
                <p class="mb-0 font-weight-bold" style="color:#f37021" v-if="row.item.OrderDescription !== ''">
                  Note : {{ row.item.OrderDescription }}
                </p>
              </b-col>

              <b-col sm="12" lg="4" class="d-none d-lg-flex flex-row justify-content-center bg-white py-3">
                <div>
                  <h5 class="font-weight-bold text-center text-dark">Order Status</h5>
                  <b-button-group v-if="row.item.OrderTypeID === 0 || row.item.OrderTypeID === 1 || row.item.OrderTypeID === 3">
                    <b-button disabled :class="row.item.OrderStatus === 'New' ? 'activeBtn' : 'deactiveBtn'">NEW</b-button>
                    <b-button
                      :disabled="
                        row.item.OrderStatus === 'Canceled' ||
                        selectedOrder.PaymentStatus === 'Unpaid' ||
                        row.item.OrderStatus === 'Ready'
                          ? true
                          : false
                      "
                      @click="UpdateToGoOrderStatus(row.item.OrderID, 2, row.item.OrderStatusID)"
                      :class="row.item.OrderStatus === 'Confirmed' ? 'activeBtn' : 'deactiveBtn'"
                      >CONFIRMED</b-button
                    >
                    <b-button
                      :disabled="
                        row.item.OrderStatus === 'Canceled' ||
                        row.item.OrderStatus === 'New' ||
                        row.item.OrderStatus === 'Confirmed' ||
                        selectedOrder.PaymentStatus === 'Unpaid'
                          ? true
                          : false
                      "
                      @click="UpdateToGoOrderStatus(row.item.OrderID, 3, row.item.OrderStatusID)"
                      :class="row.item.OrderStatus === 'Ready' ? 'activeBtn' : 'deactiveBtn'"
                      >READY</b-button
                    >
                    <b-button
                      v-if="allItemsReady"
                      :disabled="
                        row.item.OrderStatus === 'Canceled' ||
                        row.item.OrderStatus === 'New' ||
                        row.item.OrderStatus === 'Confirmed' ||
                        selectedOrder.PaymentStatus === 'Unpaid'
                          ? true
                          : false
                      "
                      size="md"
                      style="cursor:pointer"
                      class="deactiveBtn"
                      @click="makeAllServe"
                      >SERVED</b-button
                    >
                    <b-button
                      v-else
                      :disabled="
                        row.item.OrderStatus === 'Canceled' ||
                        row.item.OrderStatus === 'New' ||
                        row.item.OrderStatus === 'Confirmed' ||
                        selectedOrder.PaymentStatus === 'Unpaid'
                          ? true
                          : false
                      "
                      @click="UpdateToGoOrderStatus(row.item.OrderID, 4, row.item.OrderStatusID)"
                      :class="row.item.OrderStatus === 'Served' ? 'activeBtn' : 'deactiveBtn'"
                      >SERVED</b-button
                    >
                  </b-button-group>

                  <b-button-group v-else>
                    <b-button disabled :class="row.item.OrderStatus === 'New' ? 'activeBtn' : 'deactiveBtn'">NEW</b-button>
                    <b-button disabled :class="row.item.OrderStatus === 'Ready' ? 'activeBtn' : 'deactiveBtn'">READY</b-button>
                    <b-button disabled :class="row.item.OrderStatus === 'Served' ? 'activeBtn' : 'deactiveBtn'">SERVED</b-button>
                  </b-button-group>

                  <div class="text-center mt-3">
                    <vue-easy-print tableShow ref="easyPrint">
                      <template slot-scope="func">
                        <div id="printFactor" class="font-weight-bold">
                          <h4 style="font-size: 25px" class="font-weight-bold">
                            {{ 'Tab  ' + row.item.TabNo + ' (' + row.item.OrderType + ') ' }}
                          </h4>
                          <p class="text-dark mb-0" style="font-size: 18px">
                            {{ 'Submitted: ' + validDate(row.item.OrderDate) }}
                          </p>
                          <p class="font-weight-bold mb-0" style="font-size: 18px">Name: {{ row.item.CustomerName }}</p>
                          <p class="font-weight-bold" style="font-size: 18px">Due: {{ row.item.DueTime }}</p>
                          <div v-for="item in printFood(getTabItems)" class="item d-flex font-weight-bold flex-row py-2">
                            <div>
                              <p class="mb-0" style="font-size: 18px">
                                <span>{{ item.Quantity }}x</span>
                              </p>
                            </div>
                            <div class="px-2">
                              <p class="mb-0 d-flex flex-column" style="font-size: 18px">
                                <span>{{ item.ItemName }}</span>
                                <span style="font-size:19px" v-if="item.ItemName_SecondLang !== '' && AllowSecondLang">{{
                                  item.ItemName_SecondLang
                                }}</span>
                              </p>
                              <p class="mb-0" style="font-size: 15px">
                                <span class="d-flex flex-column">
                                  <span>{{ item.PriceComment }}</span>
                                  <span style="font-size:19px" v-if="item.PriceComment_SecondLang !== '' && AllowSecondLang">{{
                                    item.PriceComment_SecondLang
                                  }}</span>
                                </span>
                              </p>
                              <p class="mb-0" style="font-size: 15px">{{ item.Modifiers }}</p>
                              <p v-if="item.Modifiers_SecondLang !== '' && AllowSecondLang" class="mb-0" style="font-size: 15px">
                                {{ item.Modifiers_SecondLang }}
                              </p>
                              <p class="mb-0" v-if="item.Description.trim().length">
                                {{ item.Description }}
                              </p>
                            </div>
                          </div>
                          <div v-for="item in printDrinks(getTabItems)" class="item d-flex font-weight-bold flex-row py-2">
                            <div>
                              <p class="mb-0" style="font-size: 18px">
                                <span>{{ item.Quantity }}x</span>
                              </p>
                            </div>
                            <div class="px-2">
                              <p class="mb-0" style="font-size: 18px">
                                <span class="d-flex flex-column">
                                  <span
                                    >{{ item.ItemName }}
                                    <span class="mx-4" v-if="item.Alcoholic">
                                      * ALC. VERIFY AGE *
                                    </span>
                                  </span>
                                  <span style="font-size:19px" v-if="item.ItemName_SecondLang !== '' && AllowSecondLang">{{
                                    item.ItemName_SecondLang
                                  }}</span>
                                </span>
                              </p>
                              <p class="mb-0" style="font-size: 15px">
                                <span class="d-flex flex-column">
                                  <span>{{ item.PriceComment }}</span>
                                  <span style="font-size:19px" v-if="item.PriceComment_SecondLang !== '' && AllowSecondLang">{{
                                    item.PriceComment_SecondLang
                                  }}</span>
                                </span>
                              </p>
                              <p class="mb-0" style="font-size: 15px">{{ item.Modifiers }}</p>
                              <p v-if="item.Modifiers_SecondLang !== '' && AllowSecondLang" class="mb-0" style="font-size: 15px">
                                {{ item.Modifiers_SecondLang }}
                              </p>
                              <p class="mb-0" v-if="item.Description.trim().length">
                                {{ item.Description }}
                              </p>
                            </div>
                          </div>
                          <div class="mt-2" style="width: 6cm !important">
                            <p class="mb-0 small d-block font-weight-bold" v-if="row.item.OrderDescription !== ''">
                              Note : {{ row.item.OrderDescription }}
                            </p>
                          </div>
                        </div>
                      </template>
                    </vue-easy-print>
                    <!--                                        <button @click="printMe" class="bg-transparent border-0 text-primary font-weight-bold">-->
                    <!--                                            <span class="font-weight-bold">Print Tab...</span>-->
                    <!--                                        </button>-->
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="mt-3" v-if="HasActiveTicketPrinter">
                        <keep-alive>
                          <print-ticket
                            :loadPrint="loadPrint"
                            :items="getTabItems"
                            :AllowSecondLang="AllowSecondLang"
                            :serverIp="serverIp"
                            @callbackTicketPrint="callbackTicketPrint"
                            :info="row.item"
                            :disabled="activePrintTicketBtn.length"
                            :isSpecialEvent="true"
                          />
                        </keep-alive>
                      </div>
                      <div class="px-4">
                        <keep-alive>
                          <print-recipient
                            :loadPrint="loadPrint"
                            :items="getTabItems"
                            :info="row.item"
                            :AllowSecondLang="AllowSecondLang"
                            :HasActiveReceiptPrinter="HasActiveReceiptPrinter"
                            :HasActiveTicketPrinter="HasActiveTicketPrinter"
                            :RestaurantAddress="RestaurantAddress"
                            :RestaurantName="RestaurantName"
                            :RestaurantPhoneNumber="RestaurantPhoneNumber"
                            :RestaurantCity="RestaurantCity"
                            :RestaurantState="RestaurantState"
                            :RestaurantZIP="RestaurantZIP"
                            @callbackResult="callBackPrintServer"
                            :printers="printers"
                            :serverIp="serverIp"
                            @returnPrintes="returnPrintes"
                            :cardInfo="cardInfo"
                          />
                        </keep-alive>

                        <div v-if="errorPrintReciept !== null">
                          <p class="mt-3" :class="errorPrintReciept.hasError ? 'text-danger' : 'text-success'">
                            {{ errorPrintReciept.message }}
                          </p>
                        </div>
                        <div v-if="disconnectIps.length">
                          <b-btn variant="link" @click="showDeactiveIps = !showDeactiveIps">
                            Print Error Details...
                          </b-btn>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </template>
      </b-table>
      <!--            <p class="mb-0">* Partially refunded</p>-->
      <b-pagination
        v-if="totalPage > 0"
        v-model="currentPage"
        :total-rows="totalPage"
        :per-page="perPage"
        class="my-3"
      ></b-pagination>
      <b-sidebar
        v-model="orderDetailsSide"
        :backdrop-variant="'dark'"
        backdrop
        shadow
        no-header
        no-header-close
        sidebar-class="bg-white"
        id="sidebar-right"
        right
        shadow
      >
        <b-container fluid>
          <b-row>
            <b-col sm="12" class="d-flex flex-column">
              <div class="pt-3">
                <order-information :order="selectedOrder" />

                <div class="my-3" v-if="selectedOrder.OrderStatus !== 'Canceled'">
                  <UpdateCredit
                    v-if="
                      selectedOrder.PaymentStatusID === 1 ||
                        (selectedOrder.PaymentStatusID === 3 && $hasPermission([0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12]))
                    "
                    :Subtotal="selectedOrder.Subtotal + selectedOrder.Credit"
                    :Credit="Credit"
                    :orderId="selectedOrderID"
                    :order="selectedOrder"
                    @updateCredit="updateCredit"
                    :loadingBtn="loadingBtn"
                  />
                </div>

                <update-tip
                  v-if="
                    selectedOrder.PaymentStatusID === 1 &&
                      selectedOrder.OrderStatus !== 'Canceled' &&
                      $hasPermission([0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12])
                  "
                  :tip="selectedOrder.Tip_Percentage"
                  :order="selectedOrder"
                  @changeTip="changeTip"
                  ref="updateTip"
                />
              </div>

              <div class="my-3 sendText">
                <send-text-order
                  v-if="selectedOrder.OrderStatus !== 'Canceled'"
                  :disabled="showTextMessage"
                  :messages="messages"
                  :order-id="selectedOrderID"
                  :customer-phone="selectedOrder.Phone"
                />
              </div>

              <div v-if="selectedOrder.OrderStatusID !== 5 && selectedOrder.PaymentStatusID === 1">
                <tax-exemption :order="selectedOrder" @refresh="updateMasterList" />
              </div>

              <div v-if="selectedOrder.PaymentStatusID === 2 || selectedOrder.PaymentStatusID === 4">
                <send-email :value="selectedOrder" />
              </div>

              <div
                class="my-3"
                v-if="selectedOrder.OrderStatus !== 'Canceled' && $hasPermission([0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12])"
              >
                <refund-tab
                  v-if="
                    (selectedOrder.PaymentStatusID === 2 && selectedOrder.Refund < selectedOrder.Total) ||
                      (selectedOrder.PaymentStatusID === 4 && selectedOrder.Refund < selectedOrder.Total - selectedOrder.Fee)
                  "
                  :order-id="selectedOrderID"
                  :order="selectedOrder"
                  :credit="selectedOrder.PaymentStatusID === 4 ? selectedOrder.Total - selectedOrder.Fee : selectedOrder.Total"
                  :payment-status="selectedOrder.PaymentStatusID"
                  @refresh="updateMasterList"
                />
              </div>

              <div
                class="my-3"
                v-if="
                  selectedOrder.PaymentStatusID === 1 &&
                    selectedOrder.OrderStatus !== 'Canceled' &&
                    selectedOrder.Total - selectedOrder.Fee &&
                    $hasPermission([0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12])
                "
              >
                <payment-operation
                  @openCashBox="openCashBox"
                  @getReceipt="getReceipt"
                  :HasActiveReceiptPrinter="HasActiveReceiptPrinter"
                  :HasActiveTicketPrinter="HasActiveTicketPrinter"
                  :table-no="selectedOrder.TableNumber"
                  :Total="selectedOrder.Total"
                  :tab-no="selectedOrder.TabNo"
                  :isSpecial="true"
                  :order="selectedOrder"
                  :selectedFoodMenuType="selectedFoodMenuType"
                  @updateReport="updateReport"
                />
              </div>
              <div class="my-3" v-if="selectedOrder.Total - selectedOrder.Fee == '0' && selectedOrder.PaymentStatusID === 1">
                <close-tab
                  :order="selectedOrder"
                  :Total="selectedOrder.Total - selectedOrder.Fee"
                  :tab-no="selectedOrder.TabNo"
                  :table-no="selectedOrder.TableNumber"
                  :HasActiveReceiptPrinter="HasActiveReceiptPrinter"
                  :HasActiveTicketPrinter="HasActiveTicketPrinter"
                  @updateReport="updateReport"
                  @getReceipt="getReceipt"
                  @openCashBox="openCashBox"
                />
              </div>
              <div class="my-3" v-if="selectedOrder.OrderStatus !== 'Canceled'">
                <cancel-tab
                  v-if="
                    selectedOrder.PaymentStatusID === 1 ||
                      (selectedOrder.PaymentStatusID === 3 && $hasPermission([0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12]))
                  "
                  :cancelData="cancelReason"
                  @cancelOrder="cancelOrder"
                  :progressing="loadingBtn"
                  :order="selectedOrder"
                />
                <!--                                <b-btn class="font-weight-bold mb-3" v-if="selectedOrder.PaymentStatusID === 1 || selectedOrder.PaymentStatusID === 3" block variant="danger" @click="cancelModal = !cancelModal">-->
                <!--                                    Cancel Tab-->
                <!--                                </b-btn>-->
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-sidebar>

      <!-- Info modal -->
      <b-modal body-class="p-0" v-model="editModal" hide-header hide-footer>
        <edit-item
          :order="selectedOrder"
          :OrderType="OrderTypeID"
          :selectedOrderID="selectedOrderID"
          :OrderDetailID="orderDetailID"
          @deleteItem="deleteItem"
          @editItemFinaly="editItemFinaly"
          @cancelEditItem="cancelEditItem"
          :loadingBtn="loadingBtn"
          :itemLength="itemLength"
          :currentItemPrice="currentItemPrice"
          :CheckDiff="CheckDiff"
          :disabled-field="orderStatusField.orderType === 2 && orderStatusField.itemStatus !== 1"
        />
      </b-modal>
      <b-modal body-class="p-0" v-model="addModal" hide-header hide-footer>
        <add-item
          :orderTypeId="selectedOrder.OrderTypeID"
          :selectedOrderID="selectedOrderID"
          @addItemFinaly="addItemFinaly"
          @cancelAddItem="cancelAddItem"
          :loadingBtn="loadingBtn"
          :orderType="selectedOrder.OrderType"
          :specialStatus="true"
          :specialMenuType="selectedFoodMenuType"
          :selectedHourFromComponent="selectedOrder.DueTime"
        />
      </b-modal>
      <b-modal size="lg" content-class="p-0" body-class="p-0" centered hide-header hide-footer v-model="showDeactiveIps">
        <b-card no-body class="m-0">
          <b-card-header>
            <span>Print Error Details</span>
          </b-card-header>
          <b-card-body>
            <b-row>
              <b-col class="mb-0 mt-2" cols="12" v-for="item in disconnectIps">
                <div class="">
                  <p class="my-1">Printstation Name : {{ item.PrinterName + ' ' + '(' + item.IPAddress + ')' }}</p>
                  <p class="my-1 text-danger">Error : {{ item.printError }}</p>
                  <p class="my-1"></p>
                </div>
                <hr class="my-0" />
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-modal>
      <b-modal size="lg" content-class="p-0" body-class="p-0" centered hide-header hide-footer v-model="ticketError">
        <b-card no-body class="m-0">
          <b-card-header>
            <span>Print Error Details</span>
          </b-card-header>
          <b-card-body class="py-2">
            <b-row>
              <b-col class="mb-0 mt-2" cols="12">
                <div class="">
                  <p class="my-1">
                    Printstation Name : {{ printTicketErrorObject.name + ' ' + '(' + printTicketErrorObject.ip + ')' }}
                  </p>
                  <p class="my-1 text-danger">Error : {{ printTicketErrorObject.error }}</p>
                </div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-modal>
    </b-container>
  </b-overlay>
</template>

<script>
import moment from 'moment'
import UpdateCredit from './UpdateCredit'
import CancelOrder from './cancelOrder'
import EditItem from './editItem'
import config from 'SrcConfig'
import AddItem from './addItem'
import vueEasyPrint from 'vue-easy-print'
import PrintRecipient from './printRecipient'
import PrintTicket from './printTicket'
import PaymentOperation from './paymentOperation'
import JSPM from 'jsprintmanager'
import UpdateTip from '../shared/updateTip'
import SendEmail from '../shared/SendEmail'
import SplitBill from '../shared/splitBill'
import UndoSplit from '../shared/undoSplit'
import CloseTab from '../shared/CloseTab'
import RefundTab from '../shared/refundTab'
import CancelTab from '../shared/cancelTab'
import PrintSpecialOrder from '../shared/printSpecialOrder'
import PrintSpecialOrderByDue from '../shared/printSpecialOrderByDue'
import SendTextOrder from '../shared/sendTextOrder'
import MergeTab from '../shared/mergeTab'
import TaxExemption from '../shared/taxExemption'
import OrderInformation from './components/orderInformation'
import firebase from 'firebase/compat'
import '@firebase/messaging'
import ServerDisplay from '../shared/serverDisplay.vue'

export default {
  name: 'todayOrders',
  components: {
    OrderInformation,
    TaxExemption,
    MergeTab,
    SendTextOrder,
    PrintSpecialOrder,
    PrintSpecialOrderByDue,
    CancelTab,
    RefundTab,
    CloseTab,
    UndoSplit,
    SplitBill,
    SendEmail,
    AddItem,
    EditItem,
    CancelOrder,
    UpdateCredit,
    vueEasyPrint,
    PrintRecipient,
    PrintTicket,
    PaymentOperation,
    UpdateTip,
    ServerDisplay
  },
  watch: {
    '$store.state.selectedRestaurantId': {
      handler: function(newVal) {
        if (newVal) {
          let object = {
            RestaurantID: newVal,
            // UserID: localStorage.getItem('userID')
          }
          Promise.all([
            this.GetRestaurantMenuTypes(newVal),
            this.GetRestaurantKDSs(object),
            this.GetOrderCancelReason(),
            this.getPrinters(object),
            this.GetSMSMessages(),
            this.GetServerPrinterIP(object)
          ]).then(() => {
            // let modelOrder = {
            //     RestaurantID: newVal,
            //     UserID: localStorage.getItem('userID'),
            //     Filter_OrderStatus: this.Filter_OrderStatus,
            //     Search: this.Search.trim(),
            //     MenutypeID: this.selectedFoodMenuType,
            //     Filter_ServerName: '',
            //     Sort: ''
            // }
            for (let i = 0; i < 1000000; i++) {
              window.clearInterval(i)
            }
            if (this.FoodMenuTypes.length) {
              this.getItems(this.$refs.table.context)
              setInterval(() => {
                this.GetRestaurantOrders(modelOrder)
              }, this.intervalTime)
            } else {
              this.items = []
            }
          })
        }
      },
      immediate: true
    },
    items: {
      handler: function(newVal) {
        
        let findOpenRow = newVal.find(item => item._showDetails === true)
        if (!findOpenRow) {
          this.selectedRow = null
        } else {
          this.selectedRow = findOpenRow.OrderID
        }

        
        this.$api.getRestaurant.GetDashBoardRestaurantOrdersBeep_Event(this.filterTable(this.$refs.table.context),true)
      .then(res=>{
        if(!res.TabAcknowledged){
          clearInterval(this.beebInterval)
          this.beebInterval = setInterval(()=>{
            this.playSound()
          },this.beebIntervalTime)
        }else{
          clearInterval(this.beebInterval)
        }
          
      })
      .catch(()=>{})
      },
      deep: true
    }
  },
  data() {
    return {
      intervalTime: localStorage.getItem('notifStatus') !== 'granted' ? 30000 : 180000,
      beebIntervalTime:15000,
      beebInterval:null,
      orderStatusField: {
        itemStatus: '',
        orderType: ''
      },
      totalTabs:0,
      loadPrint: false,
      currentItemPrice: null,
      CheckDiff: null,
      ticketError: false,
      printTicketErrorObject: {
        name: null,
        ip: null,
        error: null
      },
      showDeactiveIps: false,
      serverIp: null,
      Search: '',
      itemLength: [],
      loading: false,
      loadingBtn: false,
      items: [],
      cardInfo: {
        paid: false,
        CardBrand: null,
        Last4: null,
        NameOnCard: null,
        Wallet: null,
        PaymentDate: null
      },
      fields: [
        {key: 'TabNo', label: 'Tab - Table No', sortable: false, sortDirection: 'desc', class: ''},
        {key: 'OrderType', label: 'Type', sortable: false, class: ''},
        {key: 'OrderStatus', label: 'Status', sortable: false, class: ''},
        {key: 'PaymentStatus', label: 'Pay', sortable: false},
        {key: 'CustomerName', label: 'Name', sortable: false, class: ''},
        {key: 'Submitted', label: 'Submitted', sortable: true, class: ''},
        {key: 'DUE', label: 'Due', sortable: true},
        {
          key: 'details',
          label: '...',
          sortable: false,
          class: this.$hasPermission([0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12]) ? 'text-center' : 'd-none'
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      totalPage: 0,
      detailsObject: {},
      selectedOrderID: null,
      TabNo: null,
      orderDetailsSide: false,
      showCrediteComponent: false,
      selectedOrder: {
        Total: null,
        Fee: null,
        Tip_Percentage: null,
        Tax: null,
        Subtotal: null,
        Credit: null,
        TabNo: null,
        Refund: 0,
        PaymentStatus: null,
        Tip: null,
        Delivery_Fee: null,
        Tax_adj: null,
        Subtotal_adj: null,
        SplitType: '',
        OrderTypeID: null,
        TableNumber: null
      },
      refundModal: false,
      refundType: 'FullRefund',
      reasonItems: [
        {text: 'Promotions', value: 'Promotions'},
        {text: 'Guest Relations', value: 'Guest Relations'},
        {text: 'Staff Meals', value: 'Staff Meals'},
        {text: 'Owner Meals', value: 'Owner Meals'},
        {text: 'Cash (No-Penny) Rounding', value: 'Cash (No-Penny) Rounding'},
        {text: 'Other', value: 'Other'}
      ],
      RefundReason: null,
      selected: '',
      soundurl: config.redirectToHome + '/images/TOGOalarm.wav',
      enableCredit: false,
      Credit: null,
      refundValue: null,
      selectedRow: null,
      sendTextModal: false,
      cancelModal: false,
      editModal: false,
      orderTypeID: '',
      OrderTypeID: '',
      orderItem: {},
      orderDetailID: null,
      AllowTogoBeep: false,
      cancelReason: [],
      messages: [],
      clientTypeID: null,
      filter: {
        btn: [
          {text: 'NEW', value: 1, selected: false},
          {text: 'CONFIRMED', value: 2, selected: false},
          {text: 'READY', value: 4, selected: false},
          {text: 'SERVED', value: 8, selected: false}
        ],
        statusTypes: [
          {text: 'ALL', value: '', selected: false},
          {text: 'OPEN', value: 'OPEN', selected: false},
          {text: 'CLOSED', value: 'CLOSED', selected: false}
        ]
      },
      Filter_OrderStatus: -1,
      Filter_KDS: -1,
      Filter_GeneralOrderStatus: 'OPEN',
      addModal: false,
      RestaurantPreparationTime: null,
      showResetBtn: false,
      kdsList: [],
      selectedKds: null,
      FoodMenuTypes: [],
      selectedFoodMenuType: null,
      AllowSecondLang: false,
      errorPrintReciept: null,
      HasActiveReceiptPrinter: false,
      HasActiveTicketPrinter: false,
      printers: [],
      disconnectIps: [],
      showDeactiveIps: false,
      RestaurantAddress: null,
      RestaurantName: null,
      RestaurantPhoneNumber: null,
      RestaurantCity: null,
      RestaurantState: null,
      RestaurantZIP: null
    }
  },
  metaInfo() {
    return {
      title: 'Special Event Orders'
    }
  },

  beforeDestroy() {
    //Delete setInterval when the component is lost
    for (let i = 0; i < 1000000; i++) {
      window.clearInterval(i)
    }
  },
  computed: {
    allItemsReady() {
      return this.getTabItems.every(item => item.OrderStatus === 3)
    },
    //show tab items by kdsid
    getTabItems() {
      this.detailsObject.RestaurantOrderDetails.forEach(item => {
        // this.$set(item, 'checked', false)
        this.$set(item, 'printed', false)
      })
      // if (this.selectedKds !== null) {
      //     return this.detailsObject.RestaurantOrderDetails.filter(item => item.KDSid === this.selectedKds)
      // } else {
      //     return this.detailsObject.RestaurantOrderDetails
      // }
      return this.detailsObject.RestaurantOrderDetails
    },
    activePrintTicketBtn() {
      return this.detailsObject.RestaurantOrderDetails.filter(i => i.checked)
    },
    filterOrdersByKds() {
      if (this.selectedKds !== null) {
        this.currentPage = 1
        //KDSs
        return this.items.filter(item => item.KDSs.match(this.selectedKds))
      } else {
        return this.items
      }
    },
    canceledItem() {
      return this.filterOrdersByKds && this.filterOrdersByKds.filter(i => i.OrderStatusID === 5)
    }
  },
  methods: {
    showPartialRefundSymbol(row) {
      if (row.item.Refund) {
        return row.item.Refund < row.item.Total ? true : false
      }
      return false
    },
    dineInAndSplitByAmount(order) {
      return order.OrderTypeID === 2 && order.SplitType === 'Amount'
    },
    showErrorPrintTicket(print) {
      this.printTicketErrorObject = {
        name: print.PrinterName,
        ip: print.PrinterIP,
        error: print.printError
      }
      this.ticketError = true
    },
    callbackTicketPrint(data) {
      const successPrinted = data
        .filter(i => !i.success)
        .map(item => {
          return item.IKey
        })
      const model = {
        // UserID: localStorage.getItem('userID'),
        RestaurantID: this.$store.state.selectedRestaurantId,
        OrderId: this.selectedOrder.OrderID,
        OrderDetailID: successPrinted
      }
      this.$api.getRestaurant.UpdateItemPrintingStaus(model).then(res => {
        if (res.success) {
          this.updateDetails()
        }
      })
    },
    GetRestaurantAllowance(object) {
      // get allowTogo beep
      //When this value is true, a beep will sound after reading the orders api
      return this.$api.getRestaurant.GetRestaurantAllowance(object).then(res => {
        if (res.success) {
          let allowBeep = res.results.AllowTogoBeep
          let AllowSecondLang = res.results.AllowSecondLang
          this.AllowTogoBeep = allowBeep
          this.AllowSecondLang = AllowSecondLang
          return res
        }
      })
    },

    filterTable(ctx) {
      // RestaurantID: newVal,
      //     UserID: localStorage.getItem('userID'),
      //     Filter_OrderStatus: this.Filter_OrderStatus,
      //     Search: this.Search.trim(),
      //     MenutypeID: this.selectedFoodMenuType,
      //     Filter_ServerName: '',
      //     Sort: ''
      const filter = {}
      filter.RestaurantID = this.$store.state.selectedRestaurantId
      ;(filter.UserID = localStorage.getItem('userID')), (filter.Filter_ServerName = "")
      filter.Search = this.Search.trim()
      filter.Filter_OrderStatus = this.Filter_OrderStatus
      filter.Filter_KDS = this.Filter_KDS
      filter.Filter_GeneralOrderStatus = this.Filter_GeneralOrderStatus
      filter.MenutypeID = this.selectedFoodMenuType
      filter.BlockSize = 10
      filter.startIndex = this.currentPage
      if (ctx.sortBy) {
        const sortType = ctx.sortDesc ? 'DESC' : 'ASC'
        filter.Sort = ctx.sortBy + ' ' + sortType
      } else {
        filter.Sort = ''
      }
      return filter
    },

    getItems(ctx) {
      let temp = JSON.parse(JSON.stringify(ctx))
      temp.MenutypeID =  this.selectedFoodMenuType
      this.$api.getRestaurant.GetDashBoardRestaurantOrdersBeep_Event(this.filterTable(temp),true)
      .then(res=>{
        if(!res.TabAcknowledged){
          clearInterval(this.beebInterval)
          this.beebInterval = setInterval(()=>{
            this.playSound()
          },this.beebIntervalTime)
        }else{
          clearInterval(this.beebInterval)
        }
          
      })
      .catch(()=>{})
      
      return this.$api.getRestaurant
        .GetRestaurantOrders_Event(this.filterTable(ctx), true)
        .then(res => {
          if (res.success) {
            this.items = res.results.RestaurantOrders
            if (this.items.length) {
              this.totalPage = this.items[0].Total_Record
            } else {
              this.totalPage = 0
            }
            this.RestaurantPhoneNumber = res.results.RestaurantPhoneNumber
            this.RestaurantAddress = res.results.RestaurantAddress
            this.RestaurantName = res.results.RestaurantName
            this.RestaurantCity = res.results.RestaurantCity
            this.RestaurantState = res.results.RestaurantState
            this.RestaurantZIP = res.results.RestaurantZIP
            let findNewItemWithToGoOrder = this.items.find(item => item.OrderStatus === 'New' && item.OrderTypeID !== 2)

            if (findNewItemWithToGoOrder) {
            }
            // get PreparationTime from  GetRestaurantPreparationTime function
            let PrepTime = res.results.DeliveryPreparationTime
            this.AllowSecondLang = res.results.AllowSecondLang
            this.items.forEach(item => {
              if (item.RemainMin === '' || item.RemainMin === null) {
              } else {
                if (
                  +item.RemainMin < (PrepTime * 20) / 100 &&
                  item.OrderTypeID !== 2 &&
                  item.OrderStatus !== 'Served' &&
                  item.OrderStatus !== 'Canceled'
                ) {
                  item._rowVariant = 'warning'
                }
              }

              this.$set(item, '_showDetails', false)
              if (this.selectedRow === item.OrderID) {
                item._showDetails = true
              }
            })
            this.totalRows = this.items.length
            return res
          }
        })
        .catch(() => {})
    },

    changeMenuType(MenutypeID) {
      this.getItems(this.$refs.table.context)
      // let modelOrder = {
      //     RestaurantID: this.$store.state.selectedRestaurantId,
      //     UserID: localStorage.getItem('userID'),
      //     Filter_OrderStatus: this.Filter_OrderStatus,
      //     Search: this.Search.trim(),
      //     MenutypeID,
      //     Filter_ServerName: '',
      //     Sort: ''
      // }
      for (let i = 0; i < 10000; i++) {
        window.clearInterval(i)
      }

      setInterval(() => {
        this.getItems(this.$refs.table.context)
      }, this.intervalTime)
    },
    GetRestaurantMenuTypes(RestaurantID) {
      let model = {
        RestaurantID,
        // UserID: localStorage.getItem('userID'),
        ItemType: 'Food'
      }
      return this.$api.getRestaurant.GetRestaurantMenutypeDropDown(model).then(res => {
        if (res.success) {
          res.results.RestaurantMenuTypeAll.forEach(item => {
            item.value = item.MenuTypeID
            item.text = item.MenuType
          })
          this.FoodMenuTypes = res.results.RestaurantMenuTypeAll.map(item => ({...item}))

          if (this.FoodMenuTypes.length) {
            this.selectedFoodMenuType = this.FoodMenuTypes[0].MenuTypeID
          } else {
            this.selectedFoodMenuType = null
          }
        } else {
          this.$showError(res.message)
        }
      })
    },
    searchInReport() {
      //reset pagination for update b-table
      this.currentPage = 1
      this.getItems(this.$refs.table.context).then(() => {
        if (this.Search !== '') {
          this.showResetBtn = true
        }
      })
    },
    changeKds() {
      this.getItems(this.$refs.table.context)
    },
    resetSearch() {
      //reset pagination for update b-table
      this.currentPage = 1
      this.loadingBtn = true
      this.Search = ''
      this.getItems(this.$refs.table.context).then(() => {
        this.showResetBtn = true
        this.loadingBtn = false
      })
    },
    printDrinks(items) {
      return items.filter(i => i.DrinkID !== 0)
    },
    printFood(items) {
      return items.filter(i => i.FoodID !== 0)
    },
    GetRestaurantPreparationTime(object) {
      //get preperation time of selected restaurant
      return this.$api.getRestaurant.GetRestaurantPreparationTime(object).then(res => {
        if (res.success) {
          this.RestaurantPreparationTime = res.results
          return res
        }
      })
    },
    GetOrderCancelReason() {
      //get orderCancel reason items
      return this.$api.getRestaurant.GetOrderCancelReason().then(res => {
        if (res.success) {
          this.cancelReason = res.results.CancelReason
        } else {
          this.$showError(res.message)
        }
      })
    },
    GetSMSMessages() {
      //get sms messages
      return this.$api.getRestaurant.GetSMSMessages().then(res => {
        if (res.success) {
          this.messages = res.results.CancelReason
        } else {
          this.$showError(res.message)
        }
      })
    },
    playSound() {
      var audio = new Audio(this.soundurl)
      audio.play()
      console.log("sound")
    },
    validDate(date) {
      moment.locale('en-ca')
      const constantDate = '1/1/1900'
      const vaiableDate = moment(date).format('D/M/YYYY')
      if (moment(constantDate).isSame(vaiableDate)) {
        return moment(date).format('hh:mm A')
      } else {
        return moment(date).format('D MMM YY - hh:mm A')
      }
      // moment.locale('en-ca');
      // return moment(date).format('D MMM YY - hh:mm A')
      // return date
    },
    openDetailsByClickOnEachRowTable(row) {
      //show details of each row
      //There are two ways to display the details of each order
      //By clicking the button and clicking on the row
      this.showDetails(row, 'byRow')
    },
    openDetailsByBtn(selectedOrder) {
      this.orderDetailsSide = true
      // this.selectedOrder = selectedOrder
      this.selectedOrderID = selectedOrder.OrderID
      this.TabNo = selectedOrder.TabNo
      //show details of each row
      //There are two ways to display the details of each order
      //By clicking the button and clicking on the row
      this.showDetails(selectedOrder, 'byBtn')
    },
    showDetails(row, type) {
      let object = {
        RestaurantID: this.$store.state.selectedRestaurantId,
        // UserID: localStorage.getItem('userID'),
        OrderID: row.OrderID
      }

      this.loading = true

      this.$api.getRestaurant
        .GetRestaurantOrderDetail(object)
        .then(res => {

          this.loading = false
          if (res.success) {
            this.selectedOrder = row
            this.selectedOrderID = row.OrderID
            this.items.forEach(i => {
              if (i.OrderID === row.OrderID) {
                i._showDetails = type === 'byBtn' ? true : !i._showDetails
              } else {
                i._showDetails = false
              }
            })
            this.detailsObject = res.results
            this.itemLength = res.results.RestaurantOrderDetails
            this.HasActiveReceiptPrinter = res.results.HasActiveReceiptPrinter
            this.HasActiveTicketPrinter = res.results.HasActiveTicketPrinter

            this.errorPrintReciept = null
            this.disconnectIps = []

            this.detailsObject.RestaurantOrderDetails.forEach(item => {
              if (row.OrderTypeID === 2) {
                this.$set(item, 'checked', false)
              } else {
                this.$set(item, 'checked', true)
              }
              if (item.PrinterIP === '' || item.PrinterIP === null) {
                this.$set(item, 'disabled', true)
                this.$set(item, 'checked', false)
              } else {
                this.$set(item, 'disabled', false)
              }
              this.$set(item, 'printed', false)
            })
            if (row.PaymentStatusID === 2) {
              let cardData = {
                OrderID: row.OrderID,
                RestaurantID: this.$store.state.selectedRestaurantId,
                // UserID: localStorage.getItem('userID')
              }
              this.GetOrderCartInfo(cardData)
            } else {
              this.cardInfo = {
                paid: false,
                CardBrand: null,
                Last4: null,
                NameOnCard: null,
                Wallet: null,
                PaymentDate: null
              }
            }
            if (row.PaymentStatusID === 1) {
              this.$refs.updateTip._data.show = false
            }
            this.updataItemViewedStatus(row.OrderID, res.results.TabAcknowledged)


          }


        })
        .catch(() => {
          this.loading = false
        })
    },
     updataItemViewedStatus(itemID,value){
      let tmp = this.items.find(el=>el.OrderID === itemID)
      let index = this.items.indexOf(tmp)
      if(index != -1){
        this.items[index].TabAcknowledged = value
      }

    },
    GetOrderCartInfo(object) {
      this.$api.getRestaurant.GetOrderCartInfo(object).then(res => {
        if (res.success) {
          this.cardInfo = res.cardInfo
          this.cardInfo.paid = true
        } else {
          this.cardInfo = {
            paid: false,
            CardBrand: null,
            Last4: null,
            NameOnCard: null,
            Wallet: null,
            PaymentDate: null
          }
        }
      })
    },

    GetRestaurantOrders(object) {
      // get restaurant orders
      return this.$api.getRestaurant.GetRestaurantOrders_Event(object, true).then(res => {
        if (res.success) {
          this.items = res.results.RestaurantOrders
          this.RestaurantPhoneNumber = res.results.RestaurantPhoneNumber
          this.RestaurantAddress = res.results.RestaurantAddress
          this.RestaurantName = res.results.RestaurantName
          this.RestaurantCity = res.results.RestaurantCity
          this.RestaurantState = res.results.RestaurantState
          this.RestaurantZIP = res.results.RestaurantZIP
          let findNewItemWithToGoOrder = this.items.find(item => item.OrderStatus === 'New' && item.OrderTypeID !== 2)
          if (findNewItemWithToGoOrder) {
          }
          // get PreparationTime from  GetRestaurantPreparationTime function
          let PrepTime = res.results.DeliveryPreparationTime
          this.AllowSecondLang = res.results.AllowSecondLang
          this.items.forEach(item => {
            if (item.RemainMin === '' || item.RemainMin === null) {
            } else {
              if (
                +item.RemainMin < (PrepTime * 20) / 100 &&
                item.OrderTypeID !== 2 &&
                item.OrderStatus !== 'Served' &&
                item.OrderStatus !== 'Canceled'
              ) {
                item._rowVariant = 'warning'
              }
            }

            this.$set(item, '_showDetails', false)
            if (this.selectedRow === item.OrderID) {
              item._showDetails = true
            }
          })
          this.totalRows = this.items.length
          return res
        }
      })
    },

    changeTip() {
      this.updateMasterList()
    },
    updateCredit() {
      this.updateMasterList()
    },
    UpdateToGoOrderStatus(OrderID, OrderStatusID, currentOrderStatusID) {
      //update order status
      if (currentOrderStatusID && currentOrderStatusID !== OrderStatusID) {
        //if user role is not KDS, then user can be update master order status
        let object = {
          RestaurantID: this.$store.state.selectedRestaurantId,
          // UserID: localStorage.getItem('userID'),
          OrderID,
          OrderStatusID
        }
        this.loading = true
        this.$api.getRestaurant.UpdateOrderStatus(object).then(res => {
          if (res.success) {
            this.updateDetails().then(() => {
              this.loading = false
              this.getItems(this.$refs.table.context)
            })
            // let model = {
            //     RestaurantID: this.$store.state.selectedRestaurantId,
            //     UserID: localStorage.getItem('userID'),
            //     Filter_OrderStatus: this.Filter_OrderStatus,
            //     Search: this.Search.trim(),
            //     MenutypeID: this.selectedFoodMenuType,
            //     Filter_ServerName: '',
            //     Sort: ''
            // }
            // this.GetRestaurantOrders(model)
          } else {
            this.loading = false
            this.$showError(res.message)
          }
        })
      } else if (!currentOrderStatusID && currentOrderStatusID !== OrderStatusID) {
        //if user role is not KDS, then user can be update master order status
        let object = {
          RestaurantID: this.$store.state.selectedRestaurantId,
          // UserID: localStorage.getItem('userID'),
          OrderID,
          OrderStatusID
        }
        this.loading = true
        this.$api.getRestaurant.UpdateOrderStatus(object).then(res => {
          if (res.success) {
            this.updateDetails().then(() => {
              this.loading = false
              this.getItems(this.$refs.table.context)
            })
          } else {
            this.loading = false
            this.$showError(res.message)
          }
        })
      }
    },
    makeAllServe() {
      const everyReady = this.getTabItems.every(item => item.OrderStatus === 3)
      if (everyReady) {
        const Statuses = this.getTabItems.map(item => {
          return {
            CancelReason: '',
            OrderStatusID: 4,
            IKey: item.IKey
          }
        })
        const model = {
          Statuses,
          RestaurantID: this.$store.state.selectedRestaurantId,
          // UserID: localStorage.getItem('userID'),
          OrderID: this.selectedOrderID
        }
        this.loading = true

        this.$api.getRestaurant
          .UpdateOrderDetailsStatusMultiple(model)
          .then(res => {
            if (res.success) {
              let object = {
                RestaurantID: this.$store.state.selectedRestaurantId,
                // UserID: localStorage.getItem('userID'),
                OrderID: this.selectedOrderID,
                OrderStatusID: 4
              }
              this.loading = true
              this.$api.getRestaurant.UpdateOrderStatus(object).then(res => {
                if (res.success) {
                  // let model = {
                  //     RestaurantID: this.$store.state.selectedRestaurantId,
                  //     UserID: localStorage.getItem('userID'),
                  //     Filter_OrderStatus: this.Filter_OrderStatus,
                  //     Search: this.Search.trim(),
                  //     MenutypeID: this.selectedFoodMenuType,
                  //     Filter_ServerName: '',
                  //     Sort: ''
                  // }
                  this.loading = false
                  this.getItems(this.$refs.table.context)
                  // this.GetRestaurantOrders(model)
                  this.updateDetails()
                } else {
                  this.loading = false
                  this.$showError(res.message)
                }
              })
            } else {
              this.loading = false
              this.$showError(res.message)
            }
          })
          .catch(() => {})
      } else {
        this.$showError('All items must be ready')
      }
    },
    UpdateToGoOrderDetailsStatus(MasterOrderStatus, MasterOrderID, IKey, DetailsStatusID, currentOrderStatus) {
      if (MasterOrderStatus !== 'New') {
        // call this api when master order status is not equal New
        if (DetailsStatusID !== currentOrderStatus) {
          let object = {
            IKey,
            RestaurantID: this.$store.state.selectedRestaurantId,
            // UserID: localStorage.getItem('userID'),
            OrderID: MasterOrderID,
            OrderStatusID: DetailsStatusID
          }
          this.$api.getRestaurant.UpdateOrderDetailsStatus(object, true).then(res => {
            if (res.success) {
              this.updateDetails().then(res => {
                document.getElementById(`status-btn-${IKey}-${DetailsStatusID}`).focus()
                this.loading = false
                this.getItems(this.$refs.table.context)

                // let items = res.results.RestaurantOrderDetails
                // if (MasterOrderStatus !== 'New') {
                //     let allReady = items.every(item => item.OrderStatus === 3)
                //     let allServed = items.every(item => item.OrderStatus === 4)
                //     let findNewItem = items.find(item => item.OrderStatus === 1)
                //     let findReadyItem = items.find
                //
                //     (item => item.OrderStatus === 3)
                //     if (findNewItem) {
                //         let object = {
                //             RestaurantID: this.$store.state.selectedRestaurantId,
                //             UserID: localStorage.getItem('userID'),
                //             OrderID: this.selectedOrderID,
                //             OrderStatusID: 2
                //         }
                //         this.loading = true
                //         this.$api.getRestaurant.UpdateOrderStatus(object).then(res => {
                //             if (res.success) {
                //                 this.loading = false
                //                 this.getItems(this.$refs.table.context)
                //                 // let model = {
                //                 //     RestaurantID: this.$store.state.selectedRestaurantId,
                //                 //     UserID: localStorage.getItem('userID'),
                //                 //     Filter_OrderStatus: this.Filter_OrderStatus,
                //                 //     Search: this.Search.trim(),
                //                 //     MenutypeID: this.selectedFoodMenuType,
                //                 //     Filter_ServerName: '',
                //                 //     Sort: ''
                //                 // }
                //                 // this.GetRestaurantOrders(model)
                //             } else {
                //                 this.loading = false
                //                 this.$showError(res.message)
                //             }
                //         })
                //     }
                //     else if (!findNewItem && findReadyItem && !allReady) {
                //         let object = {
                //             RestaurantID: this.$store.state.selectedRestaurantId,
                //             UserID: localStorage.getItem('userID'),
                //             OrderID: this.selectedOrderID,
                //             OrderStatusID: 3
                //         }
                //         this.loading = true
                //         this.$api.getRestaurant.UpdateOrderStatus(object).then(res => {
                //             if (res.success) {
                //                 this.loading = false
                //                 this.getItems(this.$refs.table.context)
                //
                //                 // let model = {
                //                 //     RestaurantID: this.$store.state.selectedRestaurantId,
                //                 //     UserID: localStorage.getItem('userID'),
                //                 //     Filter_OrderStatus: this.Filter_OrderStatus,
                //                 //     Search: this.Search.trim(),
                //                 //     MenutypeID: this.selectedFoodMenuType,
                //                 //     Filter_ServerName: '',
                //                 //     Sort: ''
                //                 // }
                //                 // this.GetRestaurantOrders(model)
                //             } else {
                //                 this.loading = false
                //                 this.$showError(res.message)
                //             }
                //         })
                //     }
                //     else if (allReady) {
                //         let object = {
                //             RestaurantID: this.$store.state.selectedRestaurantId,
                //             UserID: localStorage.getItem('userID'),
                //             OrderID: this.selectedOrderID,
                //             OrderStatusID: 3
                //         }
                //         this.loading = true
                //         this.$api.getRestaurant.UpdateOrderStatus(object).then(res => {
                //             if (res.success) {
                //                 this.loading = false
                //                 this.getItems(this.$refs.table.context)
                //                 // this.loading = false
                //                 // let model = {
                //                 //     RestaurantID: this.$store.state.selectedRestaurantId,
                //                 //     UserID: localStorage.getItem('userID'),
                //                 //     Filter_OrderStatus: this.Filter_OrderStatus,
                //                 //     Search: this.Search.trim(),
                //                 //     MenutypeID: this.selectedFoodMenuType,
                //                 //     Filter_ServerName: '',
                //                 //     Sort: ''
                //                 // }
                //                 // this.GetRestaurantOrders(model)
                //             } else {
                //                 this.loading = false
                //                 this.$showError(res.message)
                //             }
                //         })
                //     }
                //     else if (allServed) {
                //         let object = {
                //             RestaurantID: this.$store.state.selectedRestaurantId,
                //             UserID: localStorage.getItem('userID'),
                //             OrderID: this.selectedOrderID,
                //             OrderStatusID: 4
                //         }
                //         this.loading = true
                //         this.$api.getRestaurant.UpdateOrderStatus(object).then(res => {
                //             if (res.success) {
                //                 this.loading = false
                //                 this.getItems(this.$refs.table.context)
                //                 // this.loading = false
                //                 // let model = {
                //                 //     RestaurantID: this.$store.state.selectedRestaurantId,
                //                 //     UserID: localStorage.getItem('userID'),
                //                 //     Filter_OrderStatus: this.Filter_OrderStatus,
                //                 //     Search: this.Search.trim(),
                //                 //     MenutypeID: this.selectedFoodMenuType,
                //                 //     Filter_ServerName: '',
                //                 //     Sort: ''
                //                 // }
                //                 // this.GetRestaurantOrders(model)
                //             } else {
                //                 this.loading = false
                //                 this.$showError(res.message)
                //             }
                //         })
                //     }
                // }
              })
            } else {
              this.$showError(res.message)
            }
          })
        }
      }
    },
    closeCancel() {
      // close cancel pop up
      this.cancelModal = false
    },
    cancelOrder(CancelReason) {
      //cancel selected order
      let object = {
        RestaurantID: this.$store.state.selectedRestaurantId,
        // UserID: localStorage.getItem('userID'),
        OrderID: this.selectedOrderID,
        OrderStatusID: 5,
        CancelReason
      }
      this.loadingBtn = true
      this.$api.getRestaurant
        .UpdateOrderStatus(object)
        .then(res => {
          if (res.success) {
            this.loadingBtn = false
            this.cancelModal = false
            this.orderDetailsSide = false
            this.updateMasterList()
          } else {
            this.$showError(res.message)
            this.loadingBtn = false
          }
        })
        .catch(() => {
          this.loadingBtn = false
        })
    },
    closeText() {
      //close send text pop up
      this.sendTextModal = false
    },
    sendMessage(data) {
      //send text for selected order
      let obj = {
        RestaurantID: this.$store.state.selectedRestaurantId,
        // UserID: localStorage.getItem('userID'),
        OrderID: this.selectedOrderID,
        textMessage: data
      }
      this.loadingBtn = true
      this.$api.getRestaurant
        .SendSMS(obj)
        .then(res => {
          if (res.success) {
            this.sendTextModal = false
            this.loadingBtn = false
          } else {
            this.$showError(res.message)
            this.loadingBtn = false
          }
        })
        .catch(() => {
          this.loadingBtn = false
        })
    },
    updateReport() {
      this.orderDetailsSide = false
      this.updateMasterList()
    },
    openCashBox() {
      this.updateMasterList(false)
      this.$refs.PrintReceipt.openCashBox()
    },
    getReceipt() {
      this.$refs.PrintReceipt.getReceiptWithOutPay()
      this.orderDetailsSide = false
    },
    updateMasterList(updateSelectedOrder = true) {
      this.getItems(this.$refs.table.context).then(res => {
        if (res.success) {
          this.items = res.results.RestaurantOrders
          let PrepTime = res.results.DeliveryPreparationTime
          this.AllowSecondLang = res.results.AllowSecondLang
          this.items.forEach(item => {
            if (item.RemainMin === '' || item.RemainMin === null) {
            } else {
              if (
                +item.RemainMin < (PrepTime * 20) / 100 &&
                item.OrderTypeID !== 2 &&
                item.OrderStatus !== 'Served' &&
                item.OrderStatus !== 'Canceled'
              ) {
                item._rowVariant = 'warning'
              }
            }
            this.$set(item, '_showDetails', false)
            if (this.selectedRow === item.OrderID) {
              item._showDetails = true
            }
          })
          this.totalRows = this.items.length
          if (updateSelectedOrder) {
            let findSelectedOrderID = this.items.find(i => i.OrderID === this.selectedOrderID)
            if (findSelectedOrderID) {
              this.selectedOrder = findSelectedOrderID
            }
          } else {
            this.orderDetailsSide = false
          }
        }
      })
      // let model = {
      //     RestaurantID: this.$store.state.selectedRestaurantId,
      //     UserID: localStorage.getItem('userID'),
      //     Filter_OrderStatus: -1,
      //     Search: this.Search.trim(),
      //     MenutypeID: this.selectedFoodMenuType,
      //     Filter_ServerName: '',
      //     Sort: ''
      // }
      // this.$api.getRestaurant.GetRestaurantOrders_Event(model, true).then(res => {
      //     if (res.success) {
      //         this.items = res.results.RestaurantOrders
      //         let PrepTime = res.results.DeliveryPreparationTime
      //         this.AllowSecondLang = res.results.AllowSecondLang
      //         this.items.forEach(item => {
      //             if (item.RemainMin === '' || item.RemainMin === null) {
      //             } else {
      //                 if ((+item.RemainMin < ((PrepTime * 20) / 100)) && (item.OrderTypeID !== 2) && (item.OrderStatus !== 'Served') && item.OrderStatus !== 'Canceled') {
      //                     item._rowVariant = 'warning'
      //                 }
      //             }
      //             this.$set(item, '_showDetails', false)
      //             if (this.selectedRow === item.OrderID) {
      //                 item._showDetails = true
      //             }
      //         })
      //         this.totalRows = this.items.length
      //         if (updateSelectedOrder) {
      //             let findSelectedOrderID = this.items.find(i => i.OrderID === this.selectedOrderID)
      //             if (findSelectedOrderID) {
      //                 this.selectedOrder = findSelectedOrderID
      //             }
      //         } else {
      //             this.orderDetailsSide = false
      //         }
      //     }
      // })
    },
    showItemByClinetTypeID(permissions) {
      //permission component
      //Using this function, we hide some elements from the kds user
      let allowed = false
      let getCurrentUserClient = localStorage.getItem('ClientTypeID')
      let find = permissions.filter(item => item === +getCurrentUserClient)
      if (find.length) {
        allowed = true
      } else {
        allowed = false
      }
      return allowed
    },
    editItem(OrderTypeID, IKey, Price) {
      this.orderStatusField = {
        itemStatus: item.OrderStatus,
        orderType: order.OrderTypeID
      }
      //show edit item pop up
      this.OrderType = OrderTypeID
      this.OrderTypeID = OrderTypeID

      this.orderDetailID = IKey
      this.editModal = true
      this.currentItemPrice = Price
      this.CheckDiff = +this.selectedOrder.Subtotal
    },
    deleteItem(OrderDetailID) {
      //Delete items in an order

      let object = {
        RestaurantID: this.$store.state.selectedRestaurantId,
        IKey: OrderDetailID
      }
      this.loadingBtn = true
      this.$api.getRestaurant
        .DeleteOrderItem(object)
        .then(res => {
          if (res.success) {
            this.editModal = false
            this.loadingBtn = false
            this.updateDetails()
            this.updateMasterList()
          } else {
            this.loadingBtn = false
            this.$showError(res.message)
          }
        })
        .catch(() => {
          this.loadingBtn = false
        })
    },
    editItemFinaly(data) {
      //edit item
      this.loadingBtn = true
      this.$api.getRestaurant
        .UpdateOrderAddItem(data)
        .then(res => {
          if (res.success) {
            this.loadingBtn = false
            this.editModal = false
            if (data.open) {
              const model = {
                PrinterID: data.PrinterID,
                KDS: data.KDS,
                OrderDetailID: data.IKey,
                OrderID: data.OrderID,
                RestaurantID: this.$store.state.selectedRestaurantId,
                // UserID: localStorage.getItem('userID')
              }
              return this.$api.getRestaurant.UpdateOrderDetailKDSPrinter(model).then(res => {
                if (res.success) {
                  this.updateDetails()
                  this.updateMasterList()
                }
              })
            } else {
              this.updateDetails()
              this.updateMasterList()
            }
          } else {
            this.$showError(res.message)
            this.loadingBtn = false
          }
        })
        .catch(() => {
          this.loadingBtn = false
        })
    },
    cancelEditItem(data) {
      //close pop up edit item
      this.editModal = data
    },
    changeFilterStatus(item) {
      //reset pagination for update b-table
      this.currentPage = 1
      //filter list of order by selected filter (new, confirmed, ready, served)
      // item.selected = !item.selected
      // let selectedFilter = this.filter.btn.filter(i => i.selected === true)
      // if (!selectedFilter.length) {
      //     this.Filter_OrderStatus = -1
      // } else {
      //     let sum = 0
      //     let sumFilter = selectedFilter.reduce(function (acc, current) {
      //         return Number(acc) + Number(current.value)
      //     }, sum);
      //     this.Filter_OrderStatus = sumFilter
      // }
      this.Filter_GeneralOrderStatus = item.value

      this.getItems(this.$refs.table.context)
      // let object = {
      //     RestaurantID: localStorage.getItem('selectedRestaurant'),
      //     UserID: localStorage.getItem('userID'),
      //     Filter_OrderStatus: this.Filter_OrderStatus,
      //     Search: this.Search.trim(),
      //     MenutypeID: this.selectedFoodMenuType,
      //     Filter_ServerName: '',
      //     Sort: ''
      // }
      // for(let i=0; i<1000000; i++)
      // {
      //     window.clearInterval(i);
      // }
      // if (this.FoodMenuTypes.length) {
      //     this.GetRestaurantOrders(object)
      //     setInterval(() => {
      //         this.GetRestaurantOrders(object)
      //     },30000)
      // }
    },
    addItem() {
      //show add item pop up
      this.addModal = true
    },
    cancelAddItem() {
      //hide add item pop up
      this.addModal = false
    },
    addItemFinaly(data) {
      //add item for selected order
      this.loadingBtn = true
      this.$api.getRestaurant
        .UpdateOrderAddItem(data)
        .then(res => {
          if (res.success) {
            this.loadingBtn = false
            this.addModal = false
            this.updateDetails().then(() => {
              this.updateMasterList()
            })
          } else {
            this.$showError(res.message)
            this.loadingBtn = false
          }
        })
        .catch(() => {
          this.loadingBtn = false
        })
    },
    updateDetails() {
      //update selected order information
      let object = {
        RestaurantID: this.$store.state.selectedRestaurantId,
        // UserID: localStorage.getItem('userID'),
        OrderID: this.selectedOrderID
      }
      return this.$api.getRestaurant.GetRestaurantOrderDetail(object).then(res => {
        if (res.success) {
          this.items.forEach(i => {
            if (i.RemainMin === '' || i.RemainMin === null) {
            } else {
              if (
                +i.RemainMin < (this.RestaurantPreparationTime * 20) / 100 &&
                i.OrderTypeID !== 2 &&
                i.OrderStatus !== 'Served' &&
                i.OrderStatus !== 'Canceled'
              ) {
                i._rowVariant = 'warning'
              }
            }

            if (i.OrderID === this.selectedOrderID) {
              i._showDetails = true
            } else {
              i._showDetails = false
            }
          })
          this.detailsObject = res.results
          return res
        }
      })
    },
    UpdateOrderDetailsStatus(IKey, OrderStatusID) {
      //Change the status of selected order items
      let object = {
        IKey,
        RestaurantID: this.$store.state.selectedRestaurantId,
        // UserID: localStorage.getItem('userID'),
        OrderID: this.selectedOrderID,
        OrderStatusID
      }
      this.$api.getRestaurant.UpdateOrderDetailsStatus(object, true).then(res => {
        if (res.success) {
          this.updateDetails().then(res => {
            let items = res.results.RestaurantOrderDetails
            let findNewItem = items.find(item => item.OrderStatus === 1)
            let findReadyItem = items.find(item => item.OrderStatus === 3)
            let allServed = items.every(item => item.OrderStatus === 4)
            if (findNewItem) {
              this.UpdateToGoOrderStatus(this.selectedOrderID, 1)
            }
            if (!findNewItem && findReadyItem) {
              this.UpdateToGoOrderStatus(this.selectedOrderID, 3)
            }
            if (allServed) {
              // alert('served')
              this.UpdateToGoOrderStatus(this.selectedOrderID, 4)
            }
          })
        } else {
          this.$showError(res.message)
        }
      })
    },
    GetRestaurantKDSs(object) {
      //get list of kds
      // when user role is KDS this api was called
      if (this.showItemByClinetTypeID([0, 1, 2, 3, 4, 5, 6, 7, 8, 10, 13])) {
        this.$api.getRestaurant.GetRestaurantKDSs(object).then(res => {
          if (res.success) {
            res.results.RestaurantKDS.forEach(item => {
              item.value = item.KDSID
              item.text = item.KDS
            })
            const list = res.results.RestaurantKDS
            if (list.length === 1) {
              this.Filter_KDS = res.results.RestaurantKDS[0].KDSID
              this.kdsList = res.results.RestaurantKDS
            } else {
              this.Filter_KDS = -1
              this.kdsList = [{value: -1, text: 'All'}].concat(res.results.RestaurantKDS)
            }
          }
        })
      }
    },
    getPrinters(object) {
      this.$api.getRestaurant.GetRestaurantPrinters(object).then(res => {
        if (res.success) {
          this.printers = res.results.RestaurantPrinter.filter(i => i.PrintTaskID === 2)
          this.printers.forEach(item => {
            this.$set(item, 'deactive', false)
          })
        }
      })
    },
    printMe() {
      // printTab('#printMe')
      setTimeout(() => {
        this.$refs.easyPrint.print()
      }, 1000)
    },
    callBackPrintServer(data) {
      this.errorPrintReciept = data
      // if (data.printTab) {
      //     this.printMe()
      // }
    },
    returnPrintes(data) {
      this.disconnectIps = data.filter(i => i.deactive)
    },
    GetServerPrinterIP(object) {
      this.$api.getRestaurant.GetServerPrinterIP(object).then(res => {
        if (res.success) {
          this.serverIp = res.results.serverPrinterIp
          this.onInit(this.serverIp)
        }
      })
    },
    onInit(serverIp) {
      if (serverIp && this.printers.length) {
        var _this = this
        JSPM.JSPrintManager.license_url = _this.$config.printJspmLisence
        JSPM.JSPrintManager.auto_reconnect = false
        JSPM.JSPrintManager.start(true, serverIp, 23443)
        JSPM.JSPrintManager.WS.onStatusChanged = function() {
          _this.loadPrint = true
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.sendText {
  .btn.disabled,
  .btn:disabled {
    color: #90a4ae !important;
    background: #eceff1 !important;
    border: 1px solid #eceff1 !important;
  }
}
.activeBtn {
  background: #f5c31d !important;
  border-color: #c8ced3 !important;
  font-weight: bold;
  color: #455a64 !important;
}
.deactiveBtn:disabled{
  
  background: #fff !important;
  border-color: #c8ced3 !important;
  color: #c8ced3 !important;
}
.deactiveBtn {
  color: #2979FF !important;
  background: white !important;
  font-weight: bold;
}
.headerBtn{
  color: #455a64 !important;
}
.alcoholicText {
  color: #3d5afe;
}
#printFactor {
  display: none;
}
/*@media print {*/

/*    @page {*/
/*        size:80mm !important;*/
/*        margin-top: 0.4cm !important;*/
/*        margin-left: 0.4cm !important;*/
/*        margin-right: 0.4cm !important;*/
/*        margin-bottom: 0.8cm !important;*/
/*        !*margin: 0.4cm !important;*!*/
/*    }*/
/*    .break{*/
/*        page-break-after: always;*/
/*    }*/

/*    #printFactor{*/
/*        display: block;*/
/*    }*/
/*}*/
.item {
  border-width: 0.01em !important;
  border-bottom: 0.01em solid #707070;
  padding: 3px 3px;
}
.unAvailableDisplaystation {
  font-style: italic;
  opacity: 0.5;
}
</style>
